import { render, staticRenderFns } from "./TriggerListCard.vue?vue&type=template&id=f04d1fd0&scoped=true"
import script from "./TriggerListCard.vue?vue&type=script&lang=js"
export * from "./TriggerListCard.vue?vue&type=script&lang=js"
import style0 from "./TriggerListCard.vue?vue&type=style&index=0&id=f04d1fd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f04d1fd0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VChip,VCol,VContainer,VRow})
